import type { PoOverheadOnInvoiceDTO, SupplierInvoiceDTO, SupplierInvoiceLineDTO } from '@/services/supplierInvoice.service';

export function isSupplierInvoiceOverheadLine(
  line: Pick<SupplierInvoiceLineDTO, 'po_overhead_id' | 'item_code' | 'cost_category'>
): boolean {
  return (
    !!line.po_overhead_id ||
    String(line.item_code || '').toUpperCase() === 'OVERHEAD' ||
    String(line.cost_category || '').toLowerCase() === 'overhead'
  );
}

export function sumSupplierInvoiceOverheadAmount(
  invoice: Pick<SupplierInvoiceDTO, 'overhead_amount' | 'lines'>
): number {
  if (invoice.overhead_amount != null && Number.isFinite(Number(invoice.overhead_amount))) {
    return Math.round(Number(invoice.overhead_amount) * 100) / 100;
  }
  const total = (invoice.lines ?? [])
    .filter(isSupplierInvoiceOverheadLine)
    .reduce((s, l) => s + (Number(l.amount) || 0), 0);
  return Math.round(total * 100) / 100;
}

export function getInvoicePoOverheads(
  invoice: Pick<SupplierInvoiceDTO, 'po_overheads' | 'purchaseOrder'>
): PoOverheadOnInvoiceDTO[] {
  if (Array.isArray(invoice.po_overheads) && invoice.po_overheads.length > 0) {
    return invoice.po_overheads;
  }
  const fromPo = (invoice.purchaseOrder as { overheads?: PoOverheadOnInvoiceDTO[] } | undefined)?.overheads;
  return Array.isArray(fromPo) ? fromPo : [];
}
